import { FormType } from '../../../form-types';
import { wlusAltOnlyAnswerField } from './questions';

export const wlusAltOnly: FormType<wlusAltOnlyAnswerField> = {
  name: 'Alternative Individualized GLP Weight Loss',
  questions: [
    {
      key: 'wlusAltOnly_intro',
      next: { key: 'wlusAltOnly_sex' }
    },
    {
      key: 'wlusAltOnly_sex',
      next: {
        condition: { 'wlusAltOnly_sex.male': true },
        key: 'wlusAltOnly_highestWeight',
        els: 'wlusAltOnly_pregnancyStatus'
      }
    },
    {
      key: 'wlusAltOnly_pregnancyStatus',
      next: {
        condition: { 'wlusAltOnly_pregnancyStatus.yes': true },
        key: 'wlusAltOnly_ineligible',
        els: 'wlusAltOnly_highestWeight'
      }
    },
    'wlusAltOnly_highestWeight',
    'wlusAltOnly_weightAndHeight',
    'wlusAltOnly_currentApproach',
    {
      key: 'wlusAltOnly_medicalConditionsChecklist',
      next: {
        switch: [
          {
            condition: {
              'wlusAltOnly_medicalConditionsChecklist.gastroparesis': true
            },
            key: 'wlusAltOnly_ineligible'
          },
          {
            condition: {
              'wlusAltOnly_medicalConditionsChecklist.triglycerides_over_600':
                true
            },
            key: 'wlusAltOnly_ineligible'
          },
          {
            condition: {
              'wlusAltOnly_medicalConditionsChecklist.pancreatic_cancer_or_pancreatitis':
                true
            },
            key: 'wlusAltOnly_ineligible'
          },
          {
            condition: {
              'wlusAltOnly_medicalConditionsChecklist.type1_diabetes': true
            },
            key: 'wlusAltOnly_ineligible'
          },
          {
            condition: {
              'wlusAltOnly_medicalConditionsChecklist.hypoglycemia': true
            },
            key: 'wlusAltOnly_ineligible'
          },
          {
            condition: {
              'wlusAltOnly_medicalConditionsChecklist.medullary_thyroid_cancer':
                true
            },
            key: 'wlusAltOnly_ineligible'
          },
          {
            condition: {
              'wlusAltOnly_medicalConditionsChecklist.men2_syndrome': true
            },
            key: 'wlusAltOnly_ineligible'
          },
          {
            condition: {
              'wlusAltOnly_medicalConditionsChecklist.anorexia_or_bulimia': true
            },
            key: 'wlusAltOnly_ineligible'
          },
          {
            condition: {
              'wlusAltOnly_medicalConditionsChecklist.liver_failure': true
            },
            key: 'wlusAltOnly_ineligible'
          },
          {
            condition: {
              'wlusAltOnly_medicalConditionsChecklist.ckd_stage_3b': true
            },
            key: 'wlusAltOnly_ineligible'
          },
          {
            condition: {
              'wlusAltOnly_medicalConditionsChecklist.siadh': true
            },
            key: 'wlusAltOnly_ineligible'
          },
          {
            condition: {
              'wlusAltOnly_medicalConditionsChecklist.current_symptomatic_gallstones':
                true
            },
            key: 'wlusAltOnly_ineligible'
          },
          {
            condition: {
              'wlusAltOnly_medicalConditionsChecklist.current_gallstones_without_symptoms':
                true
            },
            key: 'wlusAltOnly_consentGallstones'
          },
          {
            condition: {
              'wlusAltOnly_medicalConditionsChecklist.past_gallbladder_removal':
                true
            },
            key: 'wlusAltOnly_consentCholecystectomy'
          },
          {
            condition: {
              'wlusAltOnly_medicalConditionsChecklist.none': true
            },
            key: 'wlusAltOnly_gastricBypass6Months'
          }
        ],
        els: 'wlusAltOnly_gastricBypass6Months'
      }
    },
    {
      key: 'wlusAltOnly_consentGallstones',
      next: {
        switch: [
          {
            condition: { 'wlusAltOnly_consentGallstones.non_consent': true },
            key: 'wlusAltOnly_ineligible',
          },
          {
            condition: { 'wlusAltOnly_medicalConditionsChecklist.past_gallbladder_removal': true },
            key: 'wlusAltOnly_consentCholecystectomy'
          },
          {
            condition: { 'wlusAltOnly_consentGallstones.consent': true },
            key: 'wlusAltOnly_gastricBypass6Months'
          }
        ],
        els: 'wlusAltOnly_ineligible'

      }
    },
    {
      key: 'wlusAltOnly_consentCholecystectomy',
      next: {
        condition: { 'wlusAltOnly_consentCholecystectomy.non_consent': true },
        key: 'wlusAltOnly_ineligible',
        els: 'wlusAltOnly_gastricBypass6Months'
      }
    },
    {
      key: 'wlusAltOnly_gastricBypass6Months',
      next: {
        condition: { 'wlusAltOnly_gastricBypass6Months.yes': true },
        key: 'wlusAltOnly_ineligible',
        els: 'wlusAltOnly_allergicToGlpList'
      }
    },
    {
      key: 'wlusAltOnly_allergicToGlpList',
      next: {
        condition: { 'wlusAltOnly_allergicToGlpList.none': true },
        key: 'wlusAltOnly_diabetesMedications',
        els: 'wlusAltOnly_ineligible'
      }
    },
    {
      key: 'wlusAltOnly_diabetesMedications',
      next: {
        condition: { 'wlusAltOnly_diabetesMedications.yes': true },
        key: 'wlusAltOnly_ineligible',
        els: 'wlusAltOnly_currentOrPastTwoMonthsMedication'
      }
    },
    {
      key: 'wlusAltOnly_currentOrPastTwoMonthsMedication',
      next: {
        condition: {
          'wlusAltOnly_currentOrPastTwoMonthsMedication.none': true
        },
        key: 'wlusAltOnly_ableToInject',
        els: 'wlusAltOnly_lastTakenWhen'
      }
    },
    // New patient path
    {
      key: 'wlusAltOnly_ableToInject',
      next: {
        condition: { 'wlusAltOnly_ableToInject.yes': true },
        key: 'wlusAltOnly_otherInfoForDoctor',
        els: 'wlusAltOnly_otherInfoForDoctor'
      }
    },
    // Patients already on treatment
    {
      key: 'wlusAltOnly_lastTakenWhen',
      next: {
        switch: [
          {
            condition: { 'wlusAltOnly_lastTakenWhen.within_past_week': true },
            key: 'wlusAltOnly_lastUseDate'
          },
          {
            condition: { 'wlusAltOnly_lastTakenWhen.within_2_3_weeks': true },
            key: 'wlusAltOnly_doseDecreaseConsent'
          },
          {
            condition: { 'wlusAltOnly_lastTakenWhen.over_a_month': true },
            key: 'wlusAltOnly_restartMedicationConsent'
          }
        ],
        els: 'wlusAltOnly_mostRecentDose'
      }
    },
    {
      key: 'wlusAltOnly_doseDecreaseConsent',
      next: {
        condition: { 'wlusAltOnly_doseDecreaseConsent.disagree': true },
        key: 'wlusAltOnly_ineligible',
        els: 'wlusAltOnly_lastUseDate'
      }
    },
    {
      key: 'wlusAltOnly_restartMedicationConsent',
      next: {
        condition: { 'wlusAltOnly_restartMedicationConsent.disagree': true },
        key: 'wlusAltOnly_ineligible',
        els: 'wlusAltOnly_lastUseDate'
      }
    },
    'wlusAltOnly_lastUseDate',
    {
      key: 'wlusAltOnly_mostRecentDose',
      next: {
        switch: [
          {
            condition: { 'wlusAltOnly_mostRecentDose.dont_see_my_dose': true },
            key: 'wlusAltOnly_currentDoseFreeText'
          },
          {
            condition: { 'wlusAltOnly_mostRecentDose.dont_know_my_dose': true },
            key: 'wlusAltOnly_brandOrCompounded'
          }
        ],
        els: 'wlusAltOnly_sideEffectsAdditives'
      }
    },
    {
      key: 'wlusAltOnly_currentDoseFreeText',
      next: { key: 'wlusAltOnly_sideEffectsAdditives' }
    },
    'wlusAltOnly_brandOrCompounded',
    'wlusAltOnly_doseVerificationPhotoUpload',
    'wlusAltOnly_sideEffectsAdditives',
    'wlusAltOnly_howRespondingToMedication',
    'wlusAltOnly_howContinueTreatment',
    {
      key: 'wlusAltOnly_photoOfPrescription',
      next: {
        condition: { 'wlusAltOnly_photoOfPrescription.yes': true },
        key: 'wlusAltOnly_prescriptionImageUpload',
        els: 'wlusAltOnly_otherInfoForDoctor'
      }
    },
    'wlusAltOnly_prescriptionImageUpload',
    'wlusAltOnly_otherInfoForDoctor',
    {
      key: 'wlusAltOnly_consentTruthfulness',
      next: {
        condition: { 'wlusAltOnly_consentTruthfulness.non_consent': true },
        key: 'wlusAltOnly_ineligible',
        els: 'wlusAltOnly_consentCompoundedGlp'
      }
    },
    {
      key: 'wlusAltOnly_consentCompoundedGlp',
      next: {
        condition: { 'wlusAltOnly_consentCompoundedGlp.non_consent': true },
        key: 'wlusAltOnly_ineligible',
        els: 'wlusAltOnly_complete'
      }
    },
    'wlusAltOnly_ineligible',
    'wlusAltOnly_complete'
  ]
};
